module.exports = __webpack_public_path__ + "static/media/share-and-inspire.621822c7.png";